import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type DefinitionMapper } from '../../../ai';

import {
  type FormContainerAction,
  type FormContainerDefinition,
} from './form-container.definition';

export class FormContainerDefinitionMapper implements DefinitionMapper<'formContainer'> {
  readonly type = 'formContainer';

  extract(element: CanvasElementFrom<'formContainer'>): PartialDeep<FormContainerDefinition> {
    const content = element.props.content;

    const action: FormContainerAction =
      content.action === 'insert'
        ? { $type: 'add' }
        : { $type: 'edit', addIfRowDoesntExist: content.options?.addIfMissing ?? false };

    return {
      $type: 'formContainer',
      title: content.title.label,
      showTitle: content.title.enabled,
      iconName: content.title.icon,
      action,
      layout: {
        $type: 'auto',
        visibleFields: [],
        columnCount: content.options?.columnsCount,
      },
    };
  }
}
